import React, { Component } from 'react';
import {
  Text,
  View,
  Dimensions,
  Animated,
  Easing
} from 'react-native-web';
import constants from '../global-constants.jsx';
import styles from '../styles/styles.jsx';
import FreqFinder from '../frequency-finder.jsx';
import FlappyBird from "../assets/flappy.png";

export default class Snake extends Component {

  constructor(props) {
    super(props);

    this.birdRef = null;
    this.setBirdRef = birdRef => {
      this.birdRef = birdRef;
    }
    this.old_note = "nonee";
    this.started = false;
    this.screen_width = Dimensions.get('window').width;
    console.log(this.screen_width);
    this.screen_height = Dimensions.get("window").height - 66;
    console.log(this.screen_height);
    let offset = 15;
    this.state = {
      result: "none",
      bird: new Animated.ValueXY({ y: this.screen_height / 2, x: this.screen_width / 4 }),
      pipe1: new Animated.ValueXY({ y: 0, x: this.screen_width + 20 }),
      pipe2: new Animated.ValueXY({ y: 0, x: this.screen_width + 20 }),
      pipe3: new Animated.ValueXY({ y: 0, x: this.screen_width + 20 }),
      pipeHole1: new Animated.ValueXY({ y: this.screen_height - 280, x: this.screen_width + offset }),
      pipeHole2: new Animated.ValueXY({ y: this.screen_height - 320, x: this.screen_width + offset }),
      pipeHole3: new Animated.ValueXY({ y: this.screen_height - 180, x: this.screen_width + offset }),
      pipeHole4: new Animated.ValueXY({ y: this.screen_height - 250, x: this.screen_width + offset }),
      pipeHole5: new Animated.ValueXY({ y: this.screen_height - 150, x: this.screen_width + offset }),
      pipeHole6: new Animated.ValueXY({ y: this.screen_height - 300, x: this.screen_width + offset }),
      pipeHole7: new Animated.ValueXY({ y: this.screen_height - 320, x: this.screen_width + offset }),
      pipeHole8: new Animated.ValueXY({ y: this.screen_height - 240, x: this.screen_width + offset }),
      pipeHole9: new Animated.ValueXY({ y: this.screen_height - 240, x: this.screen_width + offset }),
      pipeHole10: new Animated.ValueXY({ y: this.screen_height - 180, x: this.screen_width + offset }),
      pipeHole11: new Animated.ValueXY({ y: this.screen_height - 210, x: this.screen_width + offset }),
      pipeHole12: new Animated.ValueXY({ y: this.screen_height - 260, x: this.screen_width + offset }),
    };


    this.slideForward1 = this.slideAcrossScreen(this.state.pipe1);
    this.slideForward2 = this.slideAcrossScreen(this.state.pipe2);
    this.slideForward3 = this.slideAcrossScreen(this.state.pipe3);
    this.slideForward4 = this.slideAcrossScreen2(this.state.pipeHole1);
    this.slideForward5 = this.slideAcrossScreen2(this.state.pipeHole2);
    this.slideForward6 = this.slideAcrossScreen2(this.state.pipeHole3);
    this.slideForward7 = this.slideAcrossScreen2(this.state.pipeHole4);
    this.slideForward8 = this.slideAcrossScreen2(this.state.pipeHole5);
    this.slideForward9 = this.slideAcrossScreen2(this.state.pipeHole6);
    this.slideForward10 = this.slideAcrossScreen2(this.state.pipeHole7);
    this.slideForward11 = this.slideAcrossScreen2(this.state.pipeHole8);
    this.slideForward12 = this.slideAcrossScreen2(this.state.pipeHole9);
    this.slideForward13 = this.slideAcrossScreen2(this.state.pipeHole10);
    this.slideForward14 = this.slideAcrossScreen2(this.state.pipeHole11);
    this.slideForward15 = this.slideAcrossScreen2(this.state.pipeHole12);

    this.teleport1 = this.teleportBack(this.state.pipe1);
    this.teleport2 = this.teleportBack(this.state.pipe2);
    this.teleport3 = this.teleportBack(this.state.pipe3);
    this.teleport4 = this.teleportBack(this.state.pipeHole1);
    this.teleport5 = this.teleportBack(this.state.pipeHole2);
    this.teleport6 = this.teleportBack(this.state.pipeHole3);
    this.teleport7 = this.teleportBack(this.state.pipeHole4);
    this.teleport8 = this.teleportBack(this.state.pipeHole5);
    this.teleport9 = this.teleportBack(this.state.pipeHole6);
    this.teleport10 = this.teleportBack(this.state.pipeHole7);
    this.teleport11 = this.teleportBack(this.state.pipeHole8);
    this.teleport12 = this.teleportBack(this.state.pipeHole9);
    this.teleport13 = this.teleportBack(this.state.pipeHole10);
    this.teleport14 = this.teleportBack(this.state.pipeHole11);
    this.teleport15 = this.teleportBack(this.state.pipeHole12);

    this.teleport34 = this.teleportBack2(this.state.pipeHole1);
    this.teleport35 = this.teleportBack2(this.state.pipeHole2);
    this.teleport36 = this.teleportBack2(this.state.pipeHole3);
    this.teleport37 = this.teleportBack2(this.state.pipeHole4);
    this.teleport38 = this.teleportBack2(this.state.pipeHole5);
    this.teleport39 = this.teleportBack2(this.state.pipeHole6);
    this.teleport310 = this.teleportBack2(this.state.pipeHole7);
    this.teleport311 = this.teleportBack2(this.state.pipeHole8);
    this.teleport312 = this.teleportBack2(this.state.pipeHole9);
    this.teleport313 = this.teleportBack2(this.state.pipeHole10);
    this.teleport314 = this.teleportBack2(this.state.pipeHole11);
    this.teleport315 = this.teleportBack2(this.state.pipeHole12);
  }

  slideAcrossScreen(component) {
    console.log("component");
    console.log(component);
    return Animated.timing(
      component,
      {
        toValue: { y: component.y._value, x: -200 },
        duration: 9000,
        easing: Easing.in(Easing.linear),
        useNativeDriver: true,
        isInteraction: false,
      }
    );
  }

  slideAcrossScreen2(component) {
    console.log("component");
    console.log(component);
    return Animated.timing(
      component,
      {
        toValue: { y: component.y._value, x: -205 },
        duration: 9000,
        easing: Easing.in(Easing.linear),
        useNativeDriver: true,
        isInteraction: false,
      }
    );
  }

  teleportBack(component) {
    console.log("component2");
    console.log(component);
    return Animated.timing(
      component,
      {
        toValue: { y: component.y._value, x: this.screen_width + 20 },
        duration: 0,
        easing: Easing.in(Easing.linear),
        useNativeDriver: true,
      }
    );
  }
  teleportBack2(component) {
    console.log("component2");
    console.log(component);
    return Animated.timing(
      component,
      {
        toValue: { y: component.y._value, x: this.screen_width + 15 },
        duration: 27000,
        easing: Easing.in(Easing.linear),
        useNativeDriver: true,
      }
    );
  }

  moveBirdDown() {
    return Animated.timing(
      this.state.bird,
      {
        toValue: { y: this.screen_height - 10, x: this.screen_width / 4 },
        duration: 1000,
        easing: Easing.in(Easing.quad),
        useNativeDriver: true,
      }
    );
  }
  moveBirdUp(x_pos) {
    console.log(this.state.bird);
    return Animated.timing(
      this.state.bird,
      {
        toValue: { y: (x_pos - 150), x: this.screen_width / 4 },
        duration: 500,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: true,
      }
    );
  }

  componentDidMount() {
    console.log("component did mount")
    this.initializeFreqFinder();
    this.pipeAnimations = this.getPipeAnimations();
  }

  componentWillUnmount() {
    console.log("unmounting");
    constants.freqfinder.stop();
  }

  getPipeAnimations() {
    let time1 = 3000;
    // let time2 = 18000 -  loopDelay - staggerDelay ;

    let time4 = 9000;
    let time5 = 3000;
    let time3 = 9000;

    return Animated.stagger(0, [
      Animated.stagger(time3, [
        Animated.stagger(time1, [
          Animated.loop(Animated.sequence([this.slideForward4, this.teleport4, this.teleport34])),
          Animated.loop(Animated.sequence([this.slideForward5, this.teleport5, this.teleport35])),
          Animated.loop(Animated.sequence([this.slideForward6, this.teleport6, this.teleport36]))
        ]),
        Animated.stagger(time1, [
          Animated.loop(Animated.sequence([this.slideForward7, this.teleport7, this.teleport37])),
          Animated.loop(Animated.sequence([this.slideForward8, this.teleport8, this.teleport38])),
          Animated.loop(Animated.sequence([this.slideForward9, this.teleport9, this.teleport39]))
        ]),
        Animated.stagger(time1, [
          Animated.loop(Animated.sequence([this.slideForward10, this.teleport10, this.teleport310])),
          Animated.loop(Animated.sequence([this.slideForward11, this.teleport11, this.teleport311])),
          Animated.loop(Animated.sequence([this.slideForward12, this.teleport12, this.teleport312]))
        ]),
        Animated.stagger(time1, [
          Animated.loop(Animated.sequence([this.slideForward13, this.teleport13, this.teleport313])),
          Animated.loop(Animated.sequence([this.slideForward14, this.teleport14, this.teleport314])),
          Animated.loop(Animated.sequence([this.slideForward15, this.teleport15, this.teleport315]))
        ]),
      ]),
      Animated.stagger(time5, [
        Animated.loop(Animated.stagger(time4, [this.slideForward1, this.teleport1])),
        Animated.loop(Animated.stagger(time4, [this.slideForward2, this.teleport2])),
        Animated.loop(Animated.stagger(time4, [this.slideForward3, this.teleport3]))
      ])
    ]);

  }
  static componentDidUpdate(nextProps) {
    if (nextProps.screenProps === 2) {
      constants.freqfinder.stop();
      this.initializeFreqFinder();
    }
  }

  initializeFreqFinder() {
    constants.freqfinder = new FreqFinder();
    this.setControlsScheme(this.normalOperation);
    constants.freqfinder.start(50);
  }

  setControlsScheme(controlStructure) {
    constants.freqfinder.action = (note) => {
      if (note !== this.old_note) {
        let newState = this.state;
        if (note !== "none") {
          controlStructure.bind(this)();
        }
        this.old_note = note;
        newState.result = note;
        this.setState(newState);
      }
    }
  }

  normalOperation() {
    if (this.started === false) {
      this.pipeAnimations.start();
      this.started = true;
    }
    if (this.moveBird) {
      this.moveBird.stop();
    }

    console.log(this.refs);
    let coordinate = this.birdRef.getBoundingClientRect().y;
    console.log("coordinate");
    console.log(coordinate);
    this.moveBird = Animated.sequence([this.moveBirdUp(coordinate), this.moveBirdDown()]);
    this.moveBird.start();
  }

  render() {
    console.log("timing");
    console.log(this.timing);
    let slideStyle1 = { transform: this.state.pipe1.getTranslateTransform() };
    let slideStyle2 = { transform: this.state.pipe2.getTranslateTransform() };
    let slideStyle3 = { transform: this.state.pipe3.getTranslateTransform() };
    let slideStyle4 = { transform: this.state.pipeHole1.getTranslateTransform() };
    let slideStyle5 = { transform: this.state.pipeHole2.getTranslateTransform() };
    let slideStyle6 = { transform: this.state.pipeHole3.getTranslateTransform() };
    let slideStyle7 = { transform: this.state.pipeHole4.getTranslateTransform() };
    let slideStyle8 = { transform: this.state.pipeHole5.getTranslateTransform() };
    let slideStyle9 = { transform: this.state.pipeHole6.getTranslateTransform() };
    let slideStyle10 = { transform: this.state.pipeHole7.getTranslateTransform() };
    let slideStyle11 = { transform: this.state.pipeHole8.getTranslateTransform() };
    let slideStyle12 = { transform: this.state.pipeHole9.getTranslateTransform() };
    let slideStyle13 = { transform: this.state.pipeHole10.getTranslateTransform() };
    let slideStyle14 = { transform: this.state.pipeHole11.getTranslateTransform() };
    let slideStyle15 = { transform: this.state.pipeHole12.getTranslateTransform() };
    let slideStyle16 = { transform: this.state.bird.getTranslateTransform() };

    console.log("slideStyle");
    return (
      <View style={{ flex: 1 }}>
        <Text>{this.state.result}</Text>
        <Animated.View style={[slideStyle1, styles.border]}>
        </Animated.View>
        <Animated.View style={[slideStyle2, styles.border]}>
        </Animated.View>
        <Animated.View style={[slideStyle3, styles.border]}>
        </Animated.View>


        <Animated.View style={[slideStyle4, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle5, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle6, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle7, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle8, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle9, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle10, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle11, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle12, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle13, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle14, styles.holeStyle]}>
        </Animated.View>
        <Animated.View style={[slideStyle15, styles.holeStyle]}>
        </Animated.View>


        <Animated.Image
          source={FlappyBird}
          ImageResizeMode={"stretch"}
          style={[slideStyle16, { width: 32, height: 24, position: "absolute" }]}
          ref={this.setBirdRef}
        />

      </View>);
  }
}
